// extracted by mini-css-extract-plugin
export default {"wrapper":"AreYouSure_wrapper__tSS4a","title":"AreYouSure_title__XuJ-v","description":"AreYouSure_description__5Hh4z","shine":"AreYouSure_shine__M+7qt"};